import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

import Cards from 'components/Cards';
import TypeCard from 'components/Cards/TypeCard';
import selectTypeImage0 from 'assets/images/note-modal-0.jpeg';
import selectTypeImage1 from 'assets/images/note-modal-1.jpeg';
import selectTypeImage2 from 'assets/images/submission-modal-0.jpg';

const CreateQuickNote = ({ type, updateType, openCreateNoteSettings, setModalSize }) => {
  const userInfo = useSelector((state) => state.global.userInfo);
  const project = useSelector((state) => state.projectTools.project);
  const { orgId: userOrgId } = userInfo;
  const { organizationId: projectOrgId } = project;
  const bottomRef = useRef(null);

  const canCreateFromTemplate = userOrgId === projectOrgId;

  if (!canCreateFromTemplate) {
    setModalSize('small');
  }

  useEffect(() => {
    if (type !== -1) bottomRef.current?.scrollIntoView({ bottomRef: 'smooth' });
  }, [type]);

  const handleNoteCreateValidation = () => {
    if (type === -1) {
      return false;
    }
    return true;
  };

  const handleNoteCreate = () => {
    if (handleNoteCreateValidation()) {
      openCreateNoteSettings();
    }
  };

  const desc1 = 'Create a shortcut and link all your resources across the web here in your notebook.';
  const desc2 = 'Create a new note from scratch to keep track of every last detail.';
  const desc3 = 'Create a new note from an existing note template.';

  return (
    <>
      <h4 className="cards-container__subtitle">
        Select a note type
      </h4>
      <Cards>
        <TypeCard
          selected={type === 0}
          name="new-note"
          title="Shortcut"
          desc={desc1}
          img={{
            imgUrl: selectTypeImage0,
            alt: 'Shortcut',
          }}
          onClick={() => updateType(0)}
        />
        <TypeCard
          selected={type === 1}
          name="new-note"
          title="Note"
          desc={desc2}
          img={{
            imgUrl: selectTypeImage1,
            alt: 'Note',
          }}
          onClick={() => updateType(1)}
        />
        {canCreateFromTemplate && (
          <TypeCard
            selected={type === 2}
            name="new-note"
            title="Note from template"
            desc={desc3}
            img={{
              imgUrl: selectTypeImage2,
              alt: 'Note from template',
            }}
            onClick={() => updateType(2)}
          />
        )}
      </Cards>
      <button
        className={clsx('button', type === -1 && 'button--not-allowed')}
        onClick={handleNoteCreate}
      >
        Create new note
      </button>
      <div ref={bottomRef} />
    </>
  );
};

export default CreateQuickNote;
